/**
 * We'll load only for user settings update
 */
if (window.updateUserSettingsForm = document.getElementById('userSettingsForm')) {
    document.getElementsByName("avatar")[0].addEventListener('change', function (e) {
        HTMLFormElement.prototype.submit.call(updateUserSettingsForm);
    });

}
// else {
//     console.error('User settings form was not found');
// }
